<script lang="ts">
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import UtilStorage from "@/util/Common/UtilStorage";
import axios from "axios";
import { Options, Vue } from "vue-class-component";
import { toast } from "vue3-toastify";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import { useShare } from "@vueuse/core";
import { useQRCode } from "@vueuse/integrations/useQRCode";

@Options({
  components: { StandartTemplate },
  name: "ReferralPage",
})
export default class NewReferralPage extends Vue {
  private link = "Создаем ссылку..";
  private fullShortLink = "";
  public showCopyText = false;
  public QRCode = "";

  public shareSupported = false;

  async created() {
    const { isSupported } = useShare();

    this.shareSupported = isSupported;

    const userPhone = await UtilStorage.getItem("phone");
    const generateLink = `https://${window.location.hostname}/#/connect-park-form?feedbackPhone=${userPhone}`;
    const response = await axios.post("https://force2.cc/new-short-url", {
      url: generateLink,
    });

    if (response.data?.short_url) {
      this.link = response.data.short_url.split("https://").join("");
      this.fullShortLink = response.data.short_url;

      console.log("this.link", this.link);
      this.QRCode = useQRCode(this.fullShortLink);
    } else {
      this.link = "Ошибка формирования ссылки";
    }
  }

  private copyLink() {
    if (this.fullShortLink) {
      this.showCopyText = true;

      navigator.clipboard.writeText(this.fullShortLink);

      setTimeout(() => {
        this.showCopyText = false;
      }, 4000);
    } else {
      toast("Ссылка генерируется..", {
        autoClose: 4000,
        type: "warning",
      });
    }
  }

  async share() {
    const { share } = useShare();

    await share({
      title: "MDN",
      text: "Learn web development on MDN!",
      files: this.QRCode,
      url: "https://developer.mozilla.org",
    });
  }
}
</script>

<template>
  <StandartTemplate>
    <div>
      <p class="font-medium text-lg">Реферальная программа!</p>
      <p class="mt-6 text-lg">
        Нажмите на ссылку чтобы скопировать и отправить ее друзьям!
      </p>

      <div
        class="p-6 text-4xl w-full mt-8 border-primary text-center rounded-md transition-all duration-500"
        @click="copyLink"
        :class="showCopyText ? 'bg-primary' : 'bg-yellowLight'"
      >
        <p>{{ showCopyText ? "Скопировано" : link }}</p>
      </div>
      <div v-auto-animate>
        <div
          class="flex justify-center flex-col items-center mt-6 text-center"
          v-if="QRCode"
        >
          <p class="text-lg">
            Ваш персональный реферальный <br />
            QR код
          </p>
          <img class="w-40" :src="QRCode" alt="QR code" />
        </div>
      </div>
      <!--      <button @click="share" v-if="shareSupported" class="bg-amber-400 p-3 rounded">Поделиться</button>-->
    </div>
  </StandartTemplate>
</template>
